import React from 'react';
import { Col, Row } from 'antd';
import { ProfileDropdown } from '../components/profileDropdown/ProfileDropdown/ProfileDropdown';
import { HeaderSearch } from '../components/HeaderSearch/HeaderSearch';
import { SettingsDropdown } from '../components/settingsDropdown/SettingsDropdown';
import * as S from '../Header.styles';
import { Button } from '@app/components/common/buttons/Button/Button';
import { PlusOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { canCreateIdea } from '@app/constants/kaizen-permissions';

interface MobileHeaderProps {
  toggleSider: () => void;
  isSiderOpened: boolean;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({ toggleSider, isSiderOpened }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isKaizenRoute = pathname.startsWith('/kaizen');
  const canShowCreate = isKaizenRoute && canCreateIdea();

  // Only rendered below 768px (Header picks DesktopHeader from md up), so this layout is phone-only.
  // Avatar on the left; everything else in one right-aligned group with a single, even gap.
  return (
    <Row align="middle" wrap={false}>
      <Col flex="auto">
        <ProfileDropdown />
      </Col>

      <Col flex="none">
        <S.MobileActions>
          {/* <NotificationsDropdown /> */}

          {canShowCreate && (
            <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/kaizen/actions/create-new')}>
              Tạo mới
            </Button>
          )}

          <HeaderSearch />

          <SettingsDropdown />

          <S.BurgerCol>
            <S.MobileBurger onClick={toggleSider} isCross={isSiderOpened} />
          </S.BurgerCol>
        </S.MobileActions>
      </Col>
    </Row>
  );
};
